export default __webpack_public_path__ + "static/media/plane-tickets.ac8bb53d.svg";